export const formatPrice = (price: number | string | null | undefined): string => {
  if (price === null || price === undefined) {
    return 'L. 0.00';
  }
  const numPrice = typeof price === 'number' ? price : parseFloat(price);
  if (isNaN(numPrice)) {
    return 'L. 0.00';
  }
  return `L. ${numPrice.toFixed(2)}`;
};
